import { LinguiJSMessageDescriptor } from '@lib/types/common'
import { StudentProjectDataType } from '@lib/types/student-project'

const IMAGE_PATH = '/images/student-projects-page/project-images/'

export type ProjectType = {
  studentName: string | LinguiJSMessageDescriptor
  studentImage?: string
  grade: number | string
  projectName: string | LinguiJSMessageDescriptor
  projectImage: string
  projectCategory: string | LinguiJSMessageDescriptor
  projectDescription: string | LinguiJSMessageDescriptor
  projectLink: string
  isAndroidApp?: boolean
}
export const PUBLISHED_STUDENT_PROJECTS: ProjectType[] = [
  {
    studentName: 'Saransh',
    grade: 4,
    projectName: 'The Arctic',
    projectImage: 'the-arctic',
    projectCategory: 'App development',
    projectDescription:
      'An amazing quiz app for some brainy fun with your friends and family.',
    projectLink:
      'https://play.google.com/store/apps/details?id=com.codingal.curriculum.competitionarctic',
    isAndroidApp: true,
  },
  {
    studentName: 'Saransh',
    grade: 4,
    projectName: 'Profit Calculator',
    projectImage: 'profit-calculator',
    projectCategory: 'App development',
    projectDescription:
      'A nifty app to track your finances and calculate profit and loss. No need to mess around with a calculator.',
    projectLink:
      'https://play.google.com/store/apps/details?id=com.codingal.curriculum.cool',
    isAndroidApp: true,
  },
  {
    studentName: 'Kanishk Sagar Sawant',
    grade: 4,
    projectName: 'Media Mania',
    projectImage: 'media-mania',
    projectCategory: 'App development',
    projectDescription:
      'A multipurpose app with which you can take photos, edit photos, record videos, share them and many other things.',
    projectLink:
      'https://play.google.com/store/apps/details?id=com.codingal.curriculum.mediamaniacopy',
    isAndroidApp: true,
  },
  {
    studentName: 'Sidhanth Aggarwal',
    grade: 5,
    projectName: 'Translator app',
    projectImage: 'translator-app',
    projectCategory: 'App development',
    projectDescription:
      'This is an App that can help you translate sentence into any language.',
    projectLink:
      'https://play.google.com/store/apps/details?id=com.codingal.curriculum.translatorapppro',
    isAndroidApp: true,
  },
  {
    studentName: 'Aadhya Venkatraman',
    grade: 6,
    projectName: 'My app',
    projectImage: 'my-app',
    projectCategory: 'App development',
    projectDescription:
      'This app contains all the apps that you have on your phone like image sharing, messaging, calling, etc.',
    projectLink:
      'https://play.google.com/store/apps/details?id=com.codingal.curriculum.myapp',
    isAndroidApp: true,
  },
  {
    studentName: 'Vivaan Kalra',
    grade: 4,
    projectName: 'Phone fever',
    projectImage: 'phone-fever',
    projectCategory: 'App development',
    projectDescription:
      'This is a multipurpose all through which you can make calls, share images, draw and do many other things.',
    projectLink:
      'https://play.google.com/store/apps/details?id=com.codingal.curriculum.myphonecopy',
    isAndroidApp: true,
  },
  {
    studentName: 'Pratik Kumar',
    grade: 0,
    projectName: 'Color Chat',
    projectImage: 'color-chat',
    projectCategory: 'App development',
    projectDescription:
      "It's a Chatting App through which ANYBODY can chat with ANYBODY ELSE from over the world! It has something which all other chatting apps don't have in them. And that's a colour feature! In my app, users can pick their own colour (through R, G, B & A sliders)and that would be their colour! Their messages worldwide will be shown in that colour only!",
    projectLink:
      'https://play.google.com/store/apps/details?id=com.codingal.curriculum.colorchat',
    isAndroidApp: true,
  },
  {
    studentName: 'Pratik Kumar',
    grade: 0,
    projectName: 'Natural Reboot',
    projectImage: 'natural-reboot',
    projectCategory: 'App development',
    projectDescription:
      'The app provides you with information about Natural disasters.',
    projectLink:
      'https://play.google.com/store/apps/details?id=com.codingal.curriculum.naturalrebootmadewithbypratikkumar',
    isAndroidApp: true,
  },
  {
    studentName: 'Ankush Kumar',
    grade: 5,
    projectName: 'Browsing App',
    projectImage: 'browsing-app',
    projectCategory: 'App development',
    projectDescription:
      'The app helps you to browse multiple websites such as Amazon, Facebook, Twitter etc.',
    projectLink:
      'https://play.google.com/store/apps/details?id=com.codingal.curriculum.allapp',
    isAndroidApp: true,
  },
  {
    studentName: 'Ankush Kumar',
    grade: 5,
    projectName: 'Calculator',
    projectImage: 'calculator',
    projectCategory: 'App development',
    projectDescription:
      'This is a Calculator App that can help you to calculations easily.',
    projectLink:
      'https://play.google.com/store/apps/details?id=com.codingal.curriculum.calculator1',
    isAndroidApp: true,
  },
  {
    studentName: 'Ankush Kumar',
    grade: 5,
    projectName: 'Login App',
    projectImage: 'login-app',
    projectCategory: 'App development',
    projectDescription:
      'This is an all in one app through which you can play mole mash game, browse Facebook, use image recogniser tool etc.',
    projectLink:
      'https://play.google.com/store/apps/details?id=com.codingal.curriculum.loginapp',
    isAndroidApp: true,
  },
  {
    studentName: 'Aarav Saggar',
    grade: 3,
    projectName: 'QR scanner',
    projectImage: 'qr-scanner',
    projectCategory: 'App development',
    projectDescription:
      'This app will help you to scan QR codes and find information about it.',
    projectLink:
      'https://play.google.com/store/apps/details?id=com.codingal.curriculum.touchmeout2',
    isAndroidApp: true,
  },
  {
    studentName: 'Suhaan Ahmed',
    grade: 4,
    projectName: 'Falcon Message',
    projectImage: 'falcon-message',
    projectCategory: 'App development',
    projectDescription:
      'This app allows you to chat with your friends using a room id.',
    projectLink:
      'https://play.google.com/store/apps/details?id=com.codingal.curriculum.falconmessage',
    isAndroidApp: true,
  },
  {
    studentName: 'Saransh',
    grade: 4,
    projectName: 'Dolphin decimal',
    projectImage: 'dolphin-decimal',
    projectCategory: 'App development',
    projectDescription:
      'This app is made so kids can practice decimals in many ways and it is very easy to understand how to play the game.',
    projectLink:
      'https://play.google.com/store/apps/details?id=com.codingal.curriculum.premium',
    isAndroidApp: true,
  },
  {
    studentName: 'Aarav Saggar',
    grade: 3,
    projectName: 'Body Mass Index [BMI] Finder',
    projectImage: 'body-mass-index',
    projectCategory: 'App development',
    projectDescription: 'Check your BMI and find out you are healthy or not',
    projectLink:
      'https://play.google.com/store/apps/details?id=com.codingal.curriculum.bodymaskindexbmifinder',
    isAndroidApp: true,
  },
  {
    studentName: 'Suhaan Ahmed',
    grade: 4,
    projectName: '3 in one app',
    projectImage: '3-in-one-app',
    projectCategory: 'App development',
    projectDescription:
      'This app has a lot of things like money counter, piano, and a browser.',
    projectLink:
      'https://play.google.com/store/apps/details?id=com.codingal.curriculum.allinoneapp',
    isAndroidApp: true,
  },
  {
    studentName: 'Shreyas Poddar',
    grade: 5,
    projectName: 'Seven Continent Quiz',
    projectImage: 'seven-continent-quiz',
    projectCategory: 'App development',
    projectDescription:
      'This app is about seven continent quiz to help everybody learn about it.',
    projectLink:
      'https://play.google.com/store/apps/details?id=com.codingal.curriculum.sevencontinentsquiz',
    isAndroidApp: true,
  },
  {
    studentName: 'Yusuf Syed',
    grade: 6,
    projectName: 'WhiteBoard',
    projectImage: 'whiteboard',
    projectCategory: 'App development',
    projectDescription:
      'Its a WhiteBoard app where user can use different colors',
    projectLink:
      'https://play.google.com/store/apps/details?id=com.codingal.curriculum.whiteboard',
    isAndroidApp: true,
  },
  {
    studentName: 'Megha Rae',
    grade: 5,
    projectName: 'Find Me!',
    projectImage: 'find-me',
    projectCategory: 'App development',
    projectDescription:
      'It contains the basic things what a mobile has like camera, email, Messages, phone calls and google maps.',
    projectLink:
      'https://play.google.com/store/apps/details?id=com.codingal.curriculum.mhttpsxthunkablecomprojects61e7d1a9a686bf00118dfcbec520d3d2067b4a18acaf6ae4e861ddbfdesigneryapp',
    isAndroidApp: true,
  },
  {
    studentName: 'Navya Verma',
    grade: 6,
    projectName: 'Calculator',
    projectImage: 'calculator2',
    projectCategory: 'App development',
    projectDescription:
      '𝚃𝚑𝚒𝚜 𝚒𝚜 𝚊𝚗 𝙲𝚊𝚕𝚌𝚞𝚕𝚊𝚝𝚘𝚛 𝚊𝚙𝚙, 𝚢𝚘𝚞 𝚌𝚊𝚗 𝚞𝚜𝚎 𝚝𝚑𝚒𝚜 𝚊𝚙𝚙 𝚝𝚘 𝚌𝚊𝚕𝚌𝚞𝚕𝚊𝚝𝚎 𝚊𝚗𝚍 𝚜𝚘𝚕𝚟𝚎 𝚢𝚘𝚞𝚛 𝚙𝚛𝚘𝚋𝚕𝚎𝚖𝚜.',
    projectLink:
      'https://play.google.com/store/apps/details?id=com.codingal.curriculum.calculatornavya',
    isAndroidApp: true,
  },
  {
    studentName: 'Sana Tanti',
    grade: 3,
    projectName: 'QR CODE SCANNER',
    projectImage: 'qr-code-scanner',
    projectCategory: 'App development',
    projectDescription:
      'It scans QR code and opens the website link which is in the QR code',
    projectLink:
      'https://play.google.com/store/apps/details?id=com.codingal.curriculum.qrcodescanner',
    isAndroidApp: true,
  },
  {
    studentName: 'Devansh',
    grade: 5,
    projectName: 'Translator App',
    projectImage: 'translator-app2',
    projectCategory: 'App development',
    projectDescription:
      "It's a translator app converting one language to another language",
    projectLink:
      'https://play.google.com/store/apps/details?id=com.codingal.curriculum.translator',
    isAndroidApp: true,
  },
  {
    studentName: 'Parth Andhare',
    grade: 7,
    projectName: 'Pedometer for Runners',
    projectImage: 'pedometer-for-runners',
    projectCategory: 'App development',
    projectDescription:
      'This app is for Runner to check the count of their steps.',
    projectLink:
      'https://play.google.com/store/apps/details?id=com.codingal.curriculum.pedometerforrunners',
    isAndroidApp: true,
  },
  {
    studentName: 'Parth Andhare',
    grade: 7,
    projectName: 'Guess the Number',
    projectImage: 'guess-the-number',
    projectCategory: 'App development',
    projectDescription:
      "It's a fun, guessing game app. Just write your number 👇here from 1 to 100 and guess it until you get correct guess.",
    projectLink:
      'https://play.google.com/store/apps/details?id=com.codingal.curriculum.guessthenumber',
    isAndroidApp: true,
  },
  {
    studentName: 'Parth Andhare',
    grade: 7,
    projectName: 'Text Translator App',
    projectImage: 'text-translator-app',
    projectCategory: 'App development',
    projectDescription:
      "Enter Your Text And Click On Speak Text To Speak Text And You Can Translate your Text. - You can Translate English Text once - You can't Speak all Languages",
    projectLink:
      'https://play.google.com/store/apps/details?id=com.codingal.curriculum.texttospeech',
    isAndroidApp: true,
  },
  {
    studentName: 'Rudra Agarwal',
    grade: 2,
    projectName: 'My App',
    projectImage: 'my-app',
    projectCategory: 'App development',
    projectDescription:
      'My app"  has mutiple functions. Some examples of what it has are - calling, texting,  emailing ,etc',
    projectLink:
      'https://play.google.com/store/apps/details?id=com.codingal.curriculum.myappcopy',
    isAndroidApp: true,
  },
  {
    studentName: 'Sree Arnav Suddharsan',
    grade: 6,
    projectName: 'Anime Quiz',
    projectImage: 'anime-quiz',
    projectCategory: 'App development',
    projectDescription: `Anime (pronounced as "aa-ni-may") is a style of animation originating in Japan that is characterized by stark colorful graphics depicting vibrant characters in action-filled plots often with fantastic or futuristic themes. It's a quiz game and the questions are about the characters. Few bonus questions are also given in this game to check the general knowledge.`,
    projectLink:
      'https://play.google.com/store/apps/details?id=com.codingal.curriculum.animequiz',
    isAndroidApp: true,
  },
  {
    studentName: 'Advitiya Rishikesh',
    grade: 6,
    projectName: 'Heath check',
    projectImage: 'health-check',
    projectCategory: 'App development',
    projectDescription: 'This app lets you calculate your BMI',
    projectLink:
      'https://play.google.com/store/apps/details?id=com.codingal.curriculum.healthcheck',
    isAndroidApp: true,
  },
  {
    studentName: 'Dhanika Sharma',
    grade: 6,
    projectName: 'History Quiz',
    projectImage: 'history-quiz',
    projectCategory: 'App development',
    projectDescription:
      'This app is about a quiz on history. This is a new method to make kids fall in love with history.',
    projectLink:
      'https://play.google.com/store/apps/details?id=com.codingal.curriculum.socquiz',
    isAndroidApp: true,
  },
  {
    studentName: 'Advitiya Rishikesh',
    grade: 6,
    projectName: 'Quiz',
    projectImage: 'quiz',
    projectCategory: 'App development',
    projectDescription:
      'This is a GK Quiz App. You get points on giving correct answers and on giving wrong answers your points get deducted',
    projectLink:
      'https://play.google.com/store/apps/details?id=com.codingal.curriculum.quiz',
    isAndroidApp: true,
  },
]

export const STUDENT_PROJECTS: StudentProjectDataType[] = [
  {
    studentName: 'Aditya Nayak',
    grade: 5,
    projectName: 'Multiplication table',
    projectLink:
      'https://studio.code.org/projects/applab/7pu0BjVf_PcxhIw0Dqmjx8Kd9iCvJTcWUg8HBuN2L80',
    projectDescription:
      'Learn multiplication in this fun & easy way by building your own multiplication table app',
    projectCategory: 'App development',
    projectVideo: `${IMAGE_PATH}multiplication-table.webm`,
  },

  {
    studentName: 'Aditya Nayak',
    grade: 5,
    projectName: 'Catch the falling stars',
    projectLink: 'https://scratch.mit.edu/projects/517271147/',
    projectDescription:
      'A fun pong game where you need to collect falling stars in a basket',
    projectCategory: 'Game development',
    projectVideo: `${IMAGE_PATH}catch-the-falling-stars.webm`,
  },
  {
    studentName: 'Suryansh',
    grade: 6,
    projectName: 'Dense vacant decimals',
    projectLink:
      'https://replit.com/@SuryanshSachdev/DenseVacantDecimals#index.html',
    projectDescription:
      'An introductory website with multiple webpages about Suryansh introducing himself',
    projectCategory: 'Website development',
    projectVideo: `${IMAGE_PATH}dense-vacant-decimals.webm`,
  },
  {
    studentName: 'Arihaan',
    grade: 5,
    projectName: 'Seven wonders of the world',
    projectLink: 'https://scratch.mit.edu/projects/527189363',
    projectDescription:
      'A story animation taking you around the world visiting the 7 wonders of the world',
    projectCategory: 'Animation',
    projectVideo: `${IMAGE_PATH}seven-wonders-of-the-world.webm`,
  },
  {
    studentName: 'Saifiyah',
    grade: 3,
    projectName: 'Victory for the shark',
    projectLink:
      'https://studio.code.org/projects/spritelab/zCc2uUYUNrFEqhw00sS-QD7E0-5A63HapbBC0dELmBA',
    projectDescription:
      'Help the shark devour the creatures of the ocean and make it his own',
    projectCategory: 'Game development',
    projectVideo: `${IMAGE_PATH}victory-for-the-shark.webm`,
  },
  {
    studentName: 'Dev',
    grade: 6,
    projectName: 'Frozen circles',
    projectLink:
      'https://studio.code.org/projects/frozen/DrQQFApSfNAMNUPlnRLemjnUA8-qSICxTjSNDkLKCx8',
    projectDescription:
      'Animation of Elsa creating beautiful circular patterns in ice while skating ',
    projectCategory: 'Animation',
    projectVideo: `${IMAGE_PATH}frozen-circles.webm`,
  },
  {
    studentName: 'Ruttvi',
    grade: 3,
    projectName: 'An apple for eternal life',
    projectLink:
      'https://studio.code.org/projects/spritelab/_lp4Vjn9wH9e-6T1JIQBiSxA2PKXQ2BEFAD9Q14K_oE',
    projectDescription:
      "Help the unicorn eat the apple of eternal life. But beware, there's a dragon guarding it. Eat or be eaten!",
    projectCategory: 'Game development',
    projectVideo: `${IMAGE_PATH}an-apple-for-eternal-life.webm`,
  },
  {
    studentName: 'Aditya',
    grade: 6,
    projectName: 'Princess & wizard',
    projectLink:
      'https://studio.code.org/projects/playlab/uZdP7ZeMoPc-oawjA7iJPD2CFRLhj_Zv8tChuX4HrVA',
    projectDescription:
      'Princess v/s Wizard: The princess fights the wizard to save her kingdom',
    projectCategory: 'Game development',
    projectVideo: `${IMAGE_PATH}princess-&-wizard.webm`,
  },
  {
    studentName: 'Avyakth',
    grade: 1,
    projectName: 'Scary Diego',
    projectLink: 'https://studio.code.org/c/1305968996',
    projectDescription:
      'Have you seen the Ice Age? Who do you think is the scariest character? Diego?',
    projectCategory: 'Animation',
    projectVideo: `${IMAGE_PATH}scary-diego.webm`,
  },
  {
    studentName: 'Parth Sharma',
    grade: 7,
    projectName: 'Jumping forever',
    projectLink: 'https://scratch.mit.edu/projects/536875777/',
    projectDescription:
      'Love jumping? Then this forever jumping Platformer game is for you. Enjoy!',
    projectCategory: 'Game development',
    projectVideo: `${IMAGE_PATH}jumping-forever.webm`,
  },
  {
    studentName: 'Azlan Tashildar',
    grade: 4,
    projectName: 'Killing Corona',
    projectLink:
      'https://studio.code.org/projects/spritelab/vEANPZlu_3F7FZhzV0GDS8lelj8dNdbMLMR_wjJ7mgE?qr=true',
    projectDescription:
      'Play this fun shooting game: Kill the coronavirus and save the world!',
    projectCategory: 'Game development',
    projectVideo: `${IMAGE_PATH}killing-corona.webm`,
  },
  {
    studentName: 'Bhavi Tushar Chavan',
    grade: 1,
    projectName: 'Frog, snake, & angel',
    projectLink: 'https://scratch.mit.edu/projects/546408701',
    projectDescription:
      'A story animation where the frog kidnaps the angel and a snake comes to her rescue',
    projectCategory: 'Scratch Project',
    projectVideo: `${IMAGE_PATH}frog-snake-&-angel.webm`,
  },
  {
    studentName: 'Sharv Nagar',
    grade: 3,
    projectName: 'Tank enemy',
    projectLink:
      'https://studio.code.org/projects/spritelab/odxxzyVN_IY7JPlCXclk2D0ff_JIsnRYJJeoxA2DWtk/edit',
    projectDescription:
      'Keep your tank safe while aiming to destroy enemy tanks coming your way',
    projectCategory: 'Game development',
    projectVideo: `${IMAGE_PATH}tank-enemy.webm`,
  },
  {
    studentName: 'Aditya Verma',
    grade: 12,
    projectName: 'Climate change website',
    projectLink: 'https://climchan.adityavermareal.repl.co/',
    projectDescription:
      'This website shares information on climate change with images showing the devastation caused by human interference',
    projectCategory: 'Website development',
    projectVideo: `${IMAGE_PATH}climate-change-website.webm`,
  },
  {
    studentName: 'Hussain Wangrelwala',
    grade: 9,
    projectName: 'AirQuality',
    projectLink: 'https://hussainw134.github.io/AirQuality/',
    projectDescription:
      'This project uses the user location to show the pollutants in the air in that region.',
    projectCategory: 'Website development',
    projectVideo: `${IMAGE_PATH}air-quality.webm`,
  },
  {
    studentName: 'Shambhavi Barnwal',
    grade: 9,
    projectName: 'Climate change effects',
    projectLink:
      'https://x.thunkable.com/copy/144a7888e00b0f31aa201dbf62b71eb8',
    projectDescription:
      'Information and a quiz on effects on the environment due to human interference',
    projectCategory: 'App development',
    projectVideo: `${IMAGE_PATH}climate-change-effects.webm`,
  },
  {
    studentName: 'Arihaan',
    grade: 5,
    projectName: 'Basketball court',
    projectLink: 'https://scratch.mit.edu/projects/517066280',
    projectDescription:
      'A conversation between Aman and Ben about playing basketball',
    projectCategory: 'Scratch Project',
    projectVideo: `${IMAGE_PATH}basketball-court.webm`,
  },
  {
    studentName: 'Ira Khandelwal',
    grade: 3,
    projectName: 'Flashlight app',
    projectLink:
      'https://studio.code.org/projects/applab/q19Wl1J0jgJLaAVdsOVqeqHs52JFjJiEVjp7abR7xrI',
    projectDescription:
      'Build your own flashlight app and watch it light up your screen!',
    projectCategory: 'App development',
    projectVideo: `${IMAGE_PATH}flashlight-app.webm`,
  },
  {
    studentName: 'Vikash',
    grade: 7,
    projectName: 'Rocket mission',
    projectLink:
      'https://studio.code.org/projects/playlab/XL7w7w9y9V5xUrOIt66uzEzU-ToChA3F3qMTD-TT3vY',
    projectDescription:
      "Travel in space and help the magic dragon's friends stuck there.",
    projectCategory: 'Game development',
    projectVideo: `${IMAGE_PATH}rocket-mission.webm`,
  },
  {
    studentName: 'Adhyan',
    grade: 4,
    projectName: 'Flying bees',
    projectLink: 'https://scratch.mit.edu/projects/479526004',
    projectDescription:
      'With this sensing game, guide the butterfly to get nector from the flowers',
    projectCategory: 'Scratch Project',
    projectVideo: `${IMAGE_PATH}flying-bees.webm`,
  },
  {
    studentName: 'Aviral',
    grade: 1,
    projectName: 'Move with arrows',
    projectLink:
      'https://studio.code.org/projects/spritelab/OuSIlISkfsR-RD6XhIgUno265FRuP1LjRWfiHGaQClY',
    projectDescription:
      'This fun animation introduces you to the concepts of events & coordinates as welll as directions',
    projectCategory: 'Animation',
    projectVideo: `${IMAGE_PATH}move-with-arrows.webm`,
  },
  {
    studentName: 'Sameer',
    grade: 7,
    projectName: 'Dance with Elsa',
    projectLink:
      'https://studio.code.org/projects/frozen/aFvmWbdOAtl4YpkMgZX8qey8oRd8WPzv9JtvUyHkxwE/view',
    projectDescription:
      'Watch Elsa create a wind fan pattern on ice in this animation',
    projectCategory: 'Animation',
    projectVideo: `${IMAGE_PATH}dance-with-elsa.webm`,
  },
  {
    studentName: 'Luv',
    grade: 4,
    projectName: 'Talking duck',
    projectLink: 'https://scratch.mit.edu/projects/478140246',
    projectDescription:
      'Tom the duck is asking a few kids about their favorite gaming platforms.',
    projectCategory: 'Scratch Project',
    projectVideo: `${IMAGE_PATH}talking-duck.webm`,
  },
  {
    studentName: 'Daksh Srivastava',
    grade: 3,
    projectName: 'Covid 19 game',
    projectLink: 'https://scratch.mit.edu/projects/535046697/',
    projectDescription:
      'Reach the vaccination avoiding corona viruses and maintaining distance from the black lines.',
    projectCategory: 'Game development',
    projectVideo: `${IMAGE_PATH}covid-19-game.webm`,
  },
  {
    studentName: 'Samhith Gurajapu',
    grade: 2,
    projectName: 'Solar system',
    projectLink: 'https://scratch.mit.edu/projects/534506005',
    projectDescription:
      'Solar system animation: Click on any element to see its name and audio information',
    projectCategory: 'Animation',
    projectVideo: `${IMAGE_PATH}solar-system.webm`,
  },
  {
    studentName: 'Anvi Sikchi',
    grade: 4,
    projectName: 'Animal guessing app',
    projectLink:
      'https://studio.code.org/projects/applab/cP0piS91m9RzVt1dS3IwT6BwNIR96C18qUF2t78R5VA',
    projectDescription:
      "In this app we have to guess animal's name by the hints given.",
    projectCategory: 'App development',
    projectVideo: `${IMAGE_PATH}animal-guessing-app.webm`,
  },
  {
    studentName: 'Bhargav Kavitake',
    grade: 6,
    projectName: 'Maths and geometry calculator',
    projectLink:
      'https://x.thunkable.com/copy/cab8913f1e8737ada2719308686fede4',
    projectDescription:
      'This app helps you to do basic maths as well as geometric calculations.',
    projectCategory: 'App development',
    projectVideo: `${IMAGE_PATH}maths-and-geometry-calculator.webm`,
  },
  {
    studentName: 'Nishtha Waghela',
    grade: 6,
    projectName: 'Preschool learning app',
    projectLink:
      'https://studio.code.org/projects/applab/-ezJqg81PVLSEnY8BepWXgkMTKow8It2sWlHH8oGbSQ/',
    projectDescription:
      'This project is for preschoolers to learn basic concepts of shapes, numbers, colors, free drawing, etc',
    projectCategory: 'App development',
    projectVideo: `${IMAGE_PATH}preschool-learning-app.webm`,
  },
  {
    studentName: 'Ishan Jadhav',
    grade: 4,
    projectName: 'Space war',
    projectLink: 'https://scratch.mit.edu/projects/525112600',
    projectDescription:
      'An adventure game to shield the planet from an alien invasion with the help of Pokemons.',
    projectCategory: 'Game development',
    projectVideo: `${IMAGE_PATH}space-war.webm`,
  },
  {
    studentName: 'Nidhi Dubey',
    grade: 9,
    projectName: 'Fight against Corona',
    projectLink: 'https://spark.adobe.com/page/a2FetJzJh4RbV/',
    projectDescription:
      'This website shares information on the coronavirus - the symptoms, vaccination, tips, and common FAQs',
    projectCategory: 'Website development',
    projectVideo: `${IMAGE_PATH}fight-against-corona.webm`,
  },
  {
    studentName: 'Ansh Singh',
    grade: 9,
    projectName: 'Cov-Fight',
    projectLink: 'https://cov-fight-ansh.web.app/',
    projectDescription:
      'It is made to help people at the time of covid emergency. ',
    projectCategory: 'App development',
    projectVideo: `${IMAGE_PATH}cov-fight.webm`,
  },
  {
    studentName: 'Ridhimma Unhale',
    grade: 6,
    projectName: 'Hello world',
    projectLink: 'https://replit.com/@ReenaUnhale/hello-world#index.html',
    projectDescription:
      'This project showcases how to dynamically change elements on your website with HTML',
    projectCategory: 'Website development',
    projectVideo: `${IMAGE_PATH}hello-world.webm`,
  },
  {
    studentName: 'Shobhita',
    grade: 9,
    projectName: 'Food recipe',
    projectLink: 'https://replit.com/@hemahn1/Food-Recipe-Noodles#index.html',
    projectDescription: 'A simple multi-page website detailing a food recipe',
    projectCategory: 'Website development',
    projectVideo: `${IMAGE_PATH}food-recipe.webm`,
  },
  {
    studentName: 'Omee',
    grade: 7,
    projectName: 'Sibling conversation',
    projectLink: 'https://scratch.mit.edu/projects/508130300',
    projectDescription:
      'Check out this fun animation of 2 siblings having a conversation.',
    projectCategory: 'Scratch Project',
    projectVideo: `${IMAGE_PATH}sibling-conversation.webm`,
  },
  {
    studentName: 'Raphael Kirabo Mbonye',
    grade: 4,
    projectName: 'Car Game vertical',
    projectLink: 'https://scratch.mit.edu/projects/829923335',
    projectDescription:
      'A thrilling car game that challenges players to avoid obstacles and collect fuel to keep the car moving',
    projectCategory: 'Game development',
    projectVideo: `${IMAGE_PATH}car-game-vertical.webm`,
  },
  {
    studentName: 'Raphael Kirabo Mbonye',
    grade: 4,
    projectName: 'Flying cat',
    projectLink: 'https://scratch.mit.edu/projects/886248532',
    projectDescription:
      'Heartwarming Scratch game, guide the flying cat to catch the apples before the time runs out.',
    projectCategory: 'Game development',
    projectVideo: `${IMAGE_PATH}flying-cat.webm`,
  },
]
